export const QueryKeys = {

    DASHBOARD_CHART_DATA:'DASHBOARD_CHART_DATA',
    FAQ_LIST: 'FAQ-list',
    BOARDING: 'ONBOARDING',
    BOARDING_ID: 'ONBOARDING_ID',
    POLICY: 'PR_POLICY',
    USER_TABLE: 'TABLE_LIST',
    DASHBOARD: 'DASHBOARD_DATA',
    USERDATA: 'USER_DATA',
    STATUS: 'CHANGE_STATUS',
    CONTACT_US: 'CONTACT_US'
}